import React, { useEffect, useState } from 'react';
import './Organizations.css';
import api from '../../utils/api';
import { useNavigate } from 'react-router-dom';

function Organizations() {
  const [organizations, setOrganizations] = useState([]);
  const [sports, setSports] = useState([]);
  const [orgForm, setOrgForm] = useState({
    name: '',
    domain: '',
    slug: '',
    sportIds: [],
    logo: null,
    facebook_url: '',
    instagram_url: '',
    youtube_url: '',
  });
  const [editingOrg, setEditingOrg] = useState(null);
  const [isCreateOrgModalOpen, setIsCreateOrgModalOpen] = useState(false);
  const [isEditOrgModalOpen, setIsEditOrgModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [showOrganizations, setShowOrganizations] = useState(true);
  const [showUsers, setShowUsers] = useState(true);
  const [isEditUserModalOpen, setIsEditUserModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [userForm, setUserForm] = useState({
    organization_id: "",
    username: "",
    email: "",
    password: "",
    role: "staff",
    email_verified: true,
    resetPassword: false,
  });
  const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false);

  const navigate = useNavigate();

  const fetchOrganizations = async () => {
    try {
      const response = await api.get('/api/organizations', { withCredentials: true });
      setOrganizations(response.data.organizations || []);
    } catch (error) {
      console.error('Error fetching organizations');
    }
  };
  const fetchUsers = async () => {
    try {
      const res = await api.get('/api/usersv2', { withCredentials: true });
      setUsers(res.data.users || []);
    } catch (err) {
      console.error("Error fetching users");
    }
  };
  const fetchSports = async () => {
    try {
      const response = await api.get('/api/sportsv2', { withCredentials: true });
      setSports(response.data.sports || []);
    } catch (error) {
      console.error('Error fetching sports');
    }
  };

  useEffect(() => {
    fetchOrganizations();
    fetchSports();
    fetchUsers();
  }, []);
console.log(users)
  const openCreateOrgModal = () => {
    setOrgForm({
      name: '',
      domain: '',
      slug: '',
      sportIds: [],
      logo: null,
      facebook_url: '',
      instagram_url: '',
      youtube_url: '',
    });
    setEditingOrg(null);
    setIsCreateOrgModalOpen(true);
  };

  const openEditOrgModal = (org) => {
    setEditingOrg(org);
    setOrgForm({
      name: org.name,
      domain: org.domain || '',
      slug: org.slug || '',
      sportIds: org.sports ? org.sports.map(s => s.id) : [],
      facebook_url: org.facebook_url || '',
      instagram_url: org.instagram_url || '',
      youtube_url: org.youtube_url || '',
    });
    setIsEditOrgModalOpen(true);
  };

  const handleCreateOrganization = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      for (const key in orgForm) {
        if (key === 'sportIds') {
          orgForm.sportIds.forEach(id => formData.append('sportIds[]', id));
        } else if (key === 'logo' && orgForm.logo) {
          formData.append('logo', orgForm.logo);
        } else {
          formData.append(key, orgForm[key]);
        }
      }

      await api.post('/api/organizations', formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      await fetchOrganizations();
      setIsCreateOrgModalOpen(false);
    } catch (error) {
      console.error('Error creating organization:', error);
      alert(error.response?.data?.message || 'Error creating organization');
    }
  };

  const handleUpdateOrganization = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      for (const key in orgForm) {
        if (key === 'sportIds') {
          orgForm.sportIds.forEach(id => formData.append('sportIds[]', id));
        } else if (key === 'logo' && orgForm.logo) {
          formData.append('logo', orgForm.logo);
        } else {
          formData.append(key, orgForm[key]);
        }
      }

      await api.put(`/api/organizations/${editingOrg.id}`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      await fetchOrganizations();
      setIsEditOrgModalOpen(false);
    } catch (error) {
      console.error('Error updating organization:', error);
      alert(error.response?.data?.message || 'Error updating organization');
    }
  };

  const handleDeleteOrganization = async (orgId) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this organization?');
    if (!confirmDelete) return;
    try {
      await api.delete(`/api/organizations/${orgId}`, { withCredentials: true });
      await fetchOrganizations();
    } catch (error) {
      console.error('Error deleting organization');
      alert(error.response?.data?.message || 'Error deleting organization');
    }
  };

  const handleOrgInputChange = (e) => {
    const { name, value } = e.target;
    setOrgForm(prev => ({ ...prev, [name]: value }));
  };
  const openCreateUserModal = () => {
    setEditingUser(null);
    setUserForm({
      organization_id: "",
      username: "",
      email: "",
      password: "",
      role: "staff",
      email_verified: true,
      resetPassword: false,
    });
    setIsCreateUserModalOpen(true);
  };

  const handleEditUserClick = (user) => {
    setEditingUser(user);
    setUserForm({
      organization_id: user.organization_id || "",
      username: user.username,
      email: user.email || "",
      password: "",
      role: user.role,
      email_verified: user.email_verified ?? false,
      resetPassword: false,
    });
    setIsEditUserModalOpen(true);
  };
  const handleCreateUser = async (e) => {
    e.preventDefault();

    try {
      const body = {
        organization_id: userForm.organization_id || null,
        username: userForm.username.trim(),
        email: userForm.email.trim(),
        password: userForm.password,
        role: userForm.role,
        email_verified: userForm.email_verified,
      };

      await api.post("/api/usersv2", body, {
        withCredentials: true,
      });

      await fetchUsers();
      setIsCreateUserModalOpen(false);
    } catch (err) {
      alert(err.response?.data?.message || "Error creating user");
    }
  };
  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      const body = {
        username: userForm.username,
        email: userForm.email.trim(),
        role: userForm.role,
        email_verified: userForm.email_verified,
        resetPassword: userForm.resetPassword,
      };

      const res = await api.put(`/api/usersv2/${editingUser.id}`, body, {
        withCredentials: true,
      });

      if (res.data.tempPassword) {
        alert(`Temporary Password: ${res.data.tempPassword}`);
      }

      await fetchUsers();
      setIsEditUserModalOpen(false);
    } catch (err) {
      alert(err.response?.data?.message || "Error updating user");
    }
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm("Delete this user?")) return;

    try {
      await api.delete(`/api/usersv2/${userId}`, {
        withCredentials: true,
      });

      await fetchUsers();
    } catch (err) {
      alert(err.response?.data?.message || "Error deleting user");
    }
  };

  return (
    <div className="organizations-container">

      {/* ================= ORGANIZATIONS SECTION ================= */}
      <div
        className="organizations-container-header"
        onClick={() => setShowOrganizations(prev => !prev)}
        style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <h2>
          Organizations <span>{showOrganizations ? "▲" : "▼"}</span>
        </h2>
        <button
          className="add-organization-btn"
          onClick={(e) => {
            e.stopPropagation();
            openCreateOrgModal();
          }}
        >
          + Add Organization
        </button>
      </div>

      {showOrganizations && (
        <table className="organizations-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Domain</th>
              <th>Sports</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {organizations.length === 0 ? (
              <tr>
                <td colSpan="4">No organizations yet.</td>
              </tr>
            ) : (
              organizations.map((org) => (
                <tr key={org.id} onClick={() => navigate(`/dashboard/admin/organizations/${org.id}`)}>
                  <td>{org.name}</td>
                  <td>{org.domain || 'No domain'}</td>
                  <td>
                    {org.sports && org.sports.length > 0
                      ? org.sports.map((sport) => sport.type).join(', ')
                      : '—'}
                  </td>
                  <td>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openEditOrgModal(org);
                      }}
                    >
                      ✏️
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteOrganization(org.id);
                      }}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {/* ================= USERS SECTION ================= */}
      <div
        className="organizations-container-header"
        onClick={() => setShowUsers(prev => !prev)}
        style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "40px" }}
      >
        <h2>
          Users <span>{showUsers ? "▲" : "▼"}</span>
        </h2>
        <button
          className="add-organization-btn"
          onClick={(e) => {
            e.stopPropagation();
            openCreateUserModal();
          }}
        >
          + Add User
        </button>
      </div>

      {isCreateUserModalOpen && (
        <div className="modal" onClick={() => setIsCreateUserModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Create User</h3>

            <form onSubmit={handleCreateUser}>
              <select
                value={userForm.organization_id}
                onChange={(e) =>
                  setUserForm({ ...userForm, organization_id: e.target.value })
                }
              >
                <option value="">No Organization</option>
                {organizations.map((org) => (
                  <option key={org.id} value={org.id}>
                    {org.name}
                  </option>
                ))}
              </select>

              <input
                type="text"
                value={userForm.username}
                onChange={(e) =>
                  setUserForm({ ...userForm, username: e.target.value })
                }
                placeholder="Username"
                required
              />

              <input
                type="email"
                value={userForm.email}
                onChange={(e) =>
                  setUserForm({ ...userForm, email: e.target.value })
                }
                placeholder="Email"
                required
              />

              <input
                type="text"
                value={userForm.password}
                onChange={(e) =>
                  setUserForm({ ...userForm, password: e.target.value })
                }
                placeholder="Temporary password"
                required
              />

              <select
                value={userForm.role}
                onChange={(e) =>
                  setUserForm({ ...userForm, role: e.target.value })
                }
              >
                <option value="super_admin">Super Admin</option>
                <option value="org_owner">Org Owner</option>
                <option value="staff">Staff</option>
                <option value="user">User</option>
              </select>

              <label>
                <input
                  type="checkbox"
                  checked={userForm.email_verified}
                  onChange={(e) =>
                    setUserForm({ ...userForm, email_verified: e.target.checked })
                  }
                />
                Mark email as verified
              </label>

              <button type="submit">Create</button>
              <button type="button" onClick={() => setIsCreateUserModalOpen(false)}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
      {showUsers && (
        <table className="organizations-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Created</th>
              <th>Last Login</th>
              <th>Role</th>
              <th>Organization</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="7">No users yet.</td>
              </tr>
            ) : (
              users.map((u) => (
                <tr key={u.id}>
                  <td>{u.username}</td>
                  <td>{u.email || "—"}</td>
                  <td>{u.createdAt ? new Date(u.createdAt).toLocaleDateString() : "—"}</td>
                  <td>{u.last_login_at ? new Date(u.last_login_at).toLocaleString() : "Never"}</td>
                  <td>{u.role}</td>
                  <td>{u.organization?.name || "None"}</td>
                  <td>
                    {u.organization_id && (
                      <button onClick={() => navigate(`/dashboard/admin/organizations/${u.organization_id}`)}>
                        🔍
                      </button>
                    )}
                    <button onClick={() => handleEditUserClick(u)}>✏️</button>
                    <button onClick={() => handleDeleteUser(u.id)}>🗑️</button>

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
      {isEditUserModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h3>Edit User</h3>
            <form onSubmit={handleUpdateUser}>
              <input
                type="text"
                value={userForm.username}
                onChange={(e) =>
                  setUserForm({ ...userForm, username: e.target.value })
                }
                required
              />

              <input
                type="email"
                value={userForm.email}
                onChange={(e) =>
                  setUserForm({ ...userForm, email: e.target.value })
                }
              />

              <select
                value={userForm.role}
                onChange={(e) =>
                  setUserForm({ ...userForm, role: e.target.value })
                }
              >
                <option value="super_admin">Super Admin</option>
                <option value="org_owner">Org Owner</option>
                <option value="staff">Staff</option>
                <option value="user">User</option>
              </select>
              <label>
                <input
                  type="checkbox"
                  checked={userForm.email_verified}
                  onChange={(e) =>
                    setUserForm({ ...userForm, email_verified: e.target.checked })
                  }
                />
                Email Verified
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={userForm.resetPassword}
                  onChange={(e) =>
                    setUserForm({ ...userForm, resetPassword: e.target.checked })
                  }
                />
                Reset Password
              </label>

              <button type="submit">Update</button>
              <button type="button" onClick={() => setIsEditUserModalOpen(false)}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
      {isCreateOrgModalOpen && (
        <div
          className="orgs-modal"
          onClick={() => setIsCreateOrgModalOpen(false)}
        >
          <div
            className="orgs-modal__content"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Create Organization</h3>

            <form onSubmit={handleCreateOrganization} className="orgs-modal__form">
              <input
                type="text"
                name="name"
                value={orgForm.name}
                onChange={handleOrgInputChange}
                placeholder="Organization name"
                required
              />

              <input
                type="text"
                name="slug"
                value={orgForm.slug}
                onChange={handleOrgInputChange}
                placeholder="Slug (optional) e.g. fastactionbasketball"
              />

              <input
                type="text"
                name="domain"
                value={orgForm.domain}
                onChange={handleOrgInputChange}
                placeholder="Custom domain (optional) e.g. fastactionbasketball.com"
              />

              <label className="orgs-modal__label">
                Sports
                <select
                  multiple
                  value={orgForm.sportIds}
                  onChange={(e) => {
                    const selected = Array.from(e.target.selectedOptions).map((o) =>
                      Number(o.value)
                    );
                    setOrgForm((prev) => ({ ...prev, sportIds: selected }));
                  }}
                >
                  {sports.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.type}
                    </option>
                  ))}
                </select>
              </label>

              <label className="orgs-modal__label">
                Logo (optional)
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setOrgForm((prev) => ({ ...prev, logo: e.target.files?.[0] || null }))
                  }
                />
              </label>

              <input
                type="text"
                name="facebook_url"
                value={orgForm.facebook_url}
                onChange={handleOrgInputChange}
                placeholder="Facebook URL (optional)"
              />
              <input
                type="text"
                name="instagram_url"
                value={orgForm.instagram_url}
                onChange={handleOrgInputChange}
                placeholder="Instagram URL (optional)"
              />
              <input
                type="text"
                name="youtube_url"
                value={orgForm.youtube_url}
                onChange={handleOrgInputChange}
                placeholder="YouTube URL (optional)"
              />

              <div className="orgs-modal__actions">
                <button type="submit">Create</button>
                <button type="button" onClick={() => setIsCreateOrgModalOpen(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isEditOrgModalOpen && (
        <div
          className="orgs-modal"
          onClick={() => setIsEditOrgModalOpen(false)}
        >
          <div
            className="orgs-modal__content"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Edit Organization</h3>

            <form onSubmit={handleUpdateOrganization} className="orgs-modal__form">
              <input
                type="text"
                name="name"
                value={orgForm.name}
                onChange={handleOrgInputChange}
                placeholder="Organization name"
                required
              />

              <input
                type="text"
                name="slug"
                value={orgForm.slug}
                onChange={handleOrgInputChange}
                placeholder="Slug (optional)"
              />

              <input
                type="text"
                name="domain"
                value={orgForm.domain}
                onChange={handleOrgInputChange}
                placeholder="Custom domain (optional)"
              />

              <label className="orgs-modal__label">
                Sports
                <select
                  multiple
                  value={orgForm.sportIds}
                  onChange={(e) => {
                    const selected = Array.from(e.target.selectedOptions).map((o) =>
                      Number(o.value)
                    );
                    setOrgForm((prev) => ({ ...prev, sportIds: selected }));
                  }}
                >
                  {sports.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.type}
                    </option>
                  ))}
                </select>
              </label>

              <label className="orgs-modal__label">
                Replace Logo (optional)
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setOrgForm((prev) => ({ ...prev, logo: e.target.files?.[0] || null }))
                  }
                />
              </label>

              <input
                type="text"
                name="facebook_url"
                value={orgForm.facebook_url}
                onChange={handleOrgInputChange}
                placeholder="Facebook URL (optional)"
              />
              <input
                type="text"
                name="instagram_url"
                value={orgForm.instagram_url}
                onChange={handleOrgInputChange}
                placeholder="Instagram URL (optional)"
              />
              <input
                type="text"
                name="youtube_url"
                value={orgForm.youtube_url}
                onChange={handleOrgInputChange}
                placeholder="YouTube URL (optional)"
              />

              <div className="orgs-modal__actions">
                <button type="submit">Save</button>
                <button type="button" onClick={() => setIsEditOrgModalOpen(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );

}

export default Organizations;
